// extracted by mini-css-extract-plugin
export default {"loading-wave":"Loader_loading-wave__GH1+P","loading-bar":"Loader_loading-bar__T3a48","loading-wave-animation":"Loader_loading-wave-animation__1pYIB"};